module.exports = __webpack_public_path__ + "img/wx_tips.258ffb35.png";